export default __webpack_public_path__ + "static/media/GenericNotify.2b44fe39.mp3";